(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ----------------------------------
//
// Mobile Menu Component
//
// ----------------------------------

(function($) {

	if (typeof window.MobileMenu == 'undefined') window.MobileMenu = {};

	MobileMenu = {

		state: 'closed',

		// ------------------------------------
		// Init
		// ------------------------------------

	    init: function() {

	        // Open & Close
	        $('.menu-mobile-handle-container').click(function(e){


	        	MobileMenu.toggle_menu();

	        });





	

	        // TODO: Close Nav on Link Click.
	        $('.menu-mobile  a').click(function(e){

	        	
	        	var $this = $(this);
	        	if($this.parent().hasClass('menu-item-has-children')){

	        		if(!$this.parent().hasClass('open') && !$this.parent().hasClass('no-dropdown'))
		            {
		                //-- Stop The LInk
		                e.preventDefault();

		                //-- Add The Class
		                $this.parent().addClass('open');

		                //-- Toggle Submenu
		                var $submenu = $this.parent().find('.sub-menu');
		                $submenu.slideToggle(300);
		            } else {

		            	setTimeout(MobileMenu.toggle_menu,1500);
		            	console.log("CLOSE MENU");

		            }

	        	} else {

	        		setTimeout(MobileMenu.toggle_menu,1500);
	        		
	        	}

	        });




	    },

	    // ------------------------------------
	    // Toggle Menu
	    // ------------------------------------

	    toggle_menu(){


	    	if(MobileMenu.state == 'closed'){


        		$('.menu-mobile').css('display','block');

        		setTimeout(function(){

            		$('nav.mobile').addClass('open');
            		$('.menu-mobile').addClass('open');
            		$('.top-bar').addClass('open');

        		},5);

            	MobileMenu.state = 'open';


        	} else {

        		$('.menu-mobile a').removeClass('on');


    			$('nav.mobile').removeClass('open');
        		$('.menu-mobile').removeClass('open');
        		$('.top-bar').removeClass('open');
        		MobileMenu.state = 'closed';
        		// setTimeout(function(){$('.menu-mobile').css('display','none');},300);


        	}

	    }

	}

	module.exports = MobileMenu;

})(jQuery);
}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/mobile-menu.js","/modules")